import { TextField } from "@mui/material";
import { useState } from "react";
import { useTenantTranslation } from "hooks/formatters";

export const InventoryPeriodInput = ({
  period,
  periods,
  disabled,
  onChange,
}: {
  period: string;
  periods: string[];
  disabled: boolean;
  onChange: (period: string) => void;
}) => {
  const { t } = useTenantTranslation();
  const [draft, setDraft] = useState(period);
  const next = Number(draft);
  const invalid =
    !Number.isInteger(next) ||
    next < 1 ||
    (String(next) !== period && periods.includes(String(next)));
  const commit = () => {
    if (!invalid && String(next) !== period) onChange(String(next));
  };
  return (
    <TextField
      size="small"
      type="number"
      label={t("period")}
      value={draft}
      disabled={disabled}
      error={invalid}
      slotProps={{ htmlInput: { min: 1, step: 1 } }}
      onChange={(event) => {
        setDraft(event.target.value);
      }}
      onBlur={commit}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          event.currentTarget.querySelector("input")?.blur();
        }
      }}
    />
  );
};
